import type { Point2d } from ".."
import { isPointInPolygon, isPointInPolygonInclusive } from "./isPointInPolygon"
import { whereDoSegmentsIntersect } from "./whereDoSegmentsIntersect"
import { brawl } from "../../matching/brawl"
import type { Face2dComputed } from "../../mesh"
import { nodesToEdges } from "../nodesToEdges"

export type ThingsPolygonCanDo = {
  containPolygon: (polygon: Face2dComputed) => boolean
  containPolygonInclusive: (polygon: Face2dComputed) => boolean
  overlapPolygon: (polygon: Face2dComputed) => boolean
  containPoint: (point: Point2d) => boolean
  containPointInclusive: (point: Point2d) => boolean
}

export const doesPolygon = (polygon: Face2dComputed): ThingsPolygonCanDo => ({
  containPolygon: (otherPolygon) =>
    otherPolygon.nodes.every((node) => isPointInPolygon(node, polygon)),
  containPolygonInclusive: (otherPolygon) =>
    otherPolygon.nodes.every((node) => isPointInPolygonInclusive(node, polygon)),
  overlapPolygon: (otherPolygon) => {
    const polygonEdges = nodesToEdges(polygon.nodes)
    const otherPolygonEdges = nodesToEdges(otherPolygon.nodes)
    const polygonEdgesIntersectOtherPolygon = brawl({
      teamA: polygonEdges,
      teamB: otherPolygonEdges,
      fight: (edgeA, edgeB) => {
        const intersection = whereDoSegmentsIntersect(edgeA, edgeB, {
          inclusiveMode: false,
        })

        return intersection !== null
      },
    })

    return polygonEdgesIntersectOtherPolygon
  },
  containPoint: (point) => isPointInPolygon(point, polygon),
  containPointInclusive: (point) => isPointInPolygonInclusive(point, polygon),
})
